<div class="relative z-10 flex h-full w-full max-w-full min-w-0 flex-col overflow-hidden bg-white shadow-2xl">
  <div class="flex shrink-0 items-start justify-between gap-2 border-b border-gray-100 px-4 py-3">
    <div class="min-w-0 flex-1">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'section' | translate }}
      </div>
      <div class="text-base font-bold text-gray-900">{{ 'section_fields_title' | translate }}</div>
      <div class="mt-0.5 text-xs text-gray-500">
        {{ 'section_fields_hint' | translate }}
      </div>
    </div>
    <button
      type="button"
      class="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-gray-500 hover:bg-gray-100"
      [disabled]="isSaving"
      (click)="onClose()"
    >
      <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none">close</app-icon>
    </button>
  </div>

  <div class="crm-scroll min-h-0 flex-1 overflow-x-hidden overflow-y-auto px-4 py-3 w-full">
    <div class="flex items-center justify-between">
      <div class="text-[10px] font-semibold uppercase tracking-wider text-gray-400">
        {{ 'available_fields' | translate }}
      </div>
      <div class="text-xs text-gray-400">{{ selectedCount }}/{{ totalCount }}</div>
    </div>

    <div class="mt-2 flex flex-col gap-1.5">
      <div class="flex w-full min-w-0 items-center gap-2 rounded-lg bg-white px-3 py-2 ring-1 ring-gray-100">
        <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none shrink-0 text-gray-500">group</app-icon>
        <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ 'board_v3_quick_create_clients' | translate }}</span>
        <p-toggleswitch
          class="shrink-0"
          [ngModel]="isSelected(clientsKey)"
          (ngModelChange)="setSelected(clientsKey, $event)"
        />
      </div>
      @for (field of fields; track field.identifier) {
        <div class="flex w-full min-w-0 items-center gap-2 rounded-lg bg-white px-3 py-2 ring-1 ring-gray-100">
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none shrink-0 text-gray-500">{{ field.icon || 'tune' }}</app-icon>
          <span class="min-w-0 flex-1 truncate text-sm text-gray-800">{{ field.name }}</span>
          <p-toggleswitch
            class="shrink-0"
            [ngModel]="isSelected(field.identifier)"
            (ngModelChange)="setSelected(field.identifier, $event)"
          />
        </div>
      }

    </div>
  </div>

  <div class="flex justify-center border-t border-gray-100 py-3 w-full">
    <app-button [full]="true" [disabled]="isSaving" (onChangeClick)="onApply()">
      {{ (isSaving ? 'saving' : 'board_v3_apply') | translate }}
    </app-button>
  </div>
</div>
